(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["salta-lookbook"] && !Shopify.designMode) return;
  try {
    
  class SaltaLookbook extends HTMLElement {
    connectedCallback() {
      this.carousel = this.dataset.layout === 'carousel';
      this.dialog = this.querySelector('.salta-lookbook__viewer');
      this.stage = this.querySelector('[data-look-stage]');
      this.container = this.carousel ? this.stage : this.dialog;
      this.looks = Array.from(this.querySelectorAll('.salta-lookbook__look'));
      this.current = this.querySelector('.salta-lookbook__current');
      this.indexButtons = Array.from(this.querySelectorAll('.salta-lookbook__index-button'));
      this.index = 0;

      if (!this.container || this.looks.length === 0) return;

      this.onClick = this.onClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.onClose = this.onClose.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.onBlockDeselect = this.onBlockDeselect.bind(this);

      this.addEventListener('click', this.onClick);
      this.container.addEventListener('keydown', this.onKeydown);
      if (this.dialog) this.dialog.addEventListener('close', this.onClose);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);

      const match = window.location.hash.match(/^#look-(\d+)$/);
      if (match) {
        this.open(parseInt(match[1], 10) - 1);
      } else if (this.carousel) {
        this.preload(1);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      document.documentElement.classList.remove('salta-lookbook-lock');
    }

    onClick(event) {
      const trigger = event.target.closest('[data-look-index]');
      if (trigger) {
        this.open(parseInt(trigger.dataset.lookIndex, 10));
        return;
      }
      const angleTab = event.target.closest('[data-angle-index]');
      if (angleTab) {
        this.setAngle(angleTab.closest('.salta-lookbook__look'), parseInt(angleTab.dataset.angleIndex, 10));
        return;
      }
      const angleMedia = event.target.closest('.salta-lookbook__angle-media');
      if (angleMedia && !this.carousel && window.matchMedia('(min-width: 1000px)').matches) {
        const look = angleMedia.closest('.salta-lookbook__look');
        const figures = look.querySelectorAll('.salta-lookbook__angle');
        const active = Array.from(figures).findIndex((figure) => figure.classList.contains('is-active'));
        this.setAngle(look, (active + 1) % figures.length);
        return;
      }
      if (event.target.closest('[data-look-prev]')) this.go(-1);
      else if (event.target.closest('[data-look-next]')) this.go(1);
      else if (event.target.closest('[data-look-close]') && this.dialog) this.dialog.close();
    }

    onKeydown(event) {
      if (event.target.matches('input, textarea, select')) return;
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.go(document.dir === 'rtl' ? -1 : 1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.go(document.dir === 'rtl' ? 1 : -1);
      }
    }

    onClose() {
      document.documentElement.classList.remove('salta-lookbook-lock');
      if (window.location.hash.indexOf('#look-') === 0) {
        history.replaceState(null, '', window.location.pathname + window.location.search);
      }
    }

    onBlockSelect(event) {
      if (event.detail.sectionId !== this.dataset.sectionId) return;
      const index = this.looks.findIndex((look) => look.dataset.blockId === event.detail.blockId);
      if (index > -1) this.open(index);
    }

    onBlockDeselect() {
      /* The theme editor fires deselect on any click inside the preview, so the viewer stays open; close it with the ✕ or Escape. */
    }

    open(index) {
      this.show(index);
      if (this.carousel) {
        this.revealStage();
        return;
      }
      if (!this.dialog.open) {
        this.dialog.showModal();
        document.documentElement.classList.add('salta-lookbook-lock');
      }
    }

    go(step) {
      const count = this.looks.length;
      this.show((this.index + step + count) % count);
      if (this.carousel) this.revealStage();
    }

    revealStage() {
      const top = this.stage.getBoundingClientRect().top;
      if (top < 0 || top > window.innerHeight * 0.5) {
        const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.stage.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
      }
    }

    show(index) {
      if (isNaN(index) || index < 0 || index >= this.looks.length) index = 0;

      this.looks.forEach((look, position) => {
        look.hidden = position !== index;
      });

      this.indexButtons.forEach((button, position) => {
        if (position === index) {
          button.setAttribute('aria-current', 'true');
          const strip = button.parentElement;
          if (strip && strip.scrollWidth > strip.clientWidth) {
            strip.scrollTo({ left: button.offsetLeft - strip.clientWidth / 2 + button.clientWidth / 2 });
          }
        } else {
          button.removeAttribute('aria-current');
        }
      });

      this.index = index;
      const look = this.looks[index];
      if (this.current) this.current.textContent = look.dataset.number;

      this.setAngle(look, 0);
      const angles = look.querySelector('.salta-lookbook__angles');
      if (angles) angles.scrollLeft = 0;
      if (!this.carousel && this.dialog) this.dialog.scrollTop = 0;

      history.replaceState(null, '', '#' + look.id);
      this.preload(index + 1);
      this.preload(index - 1);
    }

    setAngle(look, index) {
      if (!look) return;
      look.querySelectorAll('.salta-lookbook__angle').forEach((figure, position) => {
        figure.classList.toggle('is-active', position === index);
      });
      look.querySelectorAll('[data-angle-index]').forEach((tab, position) => {
        tab.setAttribute('aria-pressed', position === index ? 'true' : 'false');
      });
    }

    preload(index) {
      const count = this.looks.length;
      const look = this.looks[(index + count) % count];
      if (!look) return;
      look.querySelectorAll('img[loading="lazy"]').forEach((image) => {
        image.loading = 'eager';
      });
    }
  }

  if (!customElements.get('salta-lookbook')) {
    customElements.define('salta-lookbook', SaltaLookbook);
  }

  } catch(e) { console.error(e); }
})();
})();
